(function () {
  function typesOf(card) {
    return (card.getAttribute('data-ttp-types') || '').split('|').filter(Boolean);
  }

  function shuffle(panel) {
    var grid = panel.querySelector('.ttp-grid');
    var pool = panel.querySelector('template.ttp-pool');
    var limit = parseInt(panel.getAttribute('data-ttp-shuffle'), 10);
    if (!grid || !pool || !limit) return;

    var cards = Array.prototype.slice.call(grid.children)
      .concat(Array.prototype.slice.call(pool.content.children));

    for (var i = cards.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var swap = cards[i];
      cards[i] = cards[j];
      cards[j] = swap;
    }

    var used = {};
    var picked = [];
    var skipped = [];
    for (var k = 0; k < cards.length && picked.length < limit; k++) {
      var types = typesOf(cards[k]);
      if (types.some(function (type) { return used[type]; })) {
        skipped.push(cards[k]);
        continue;
      }
      types.forEach(function (type) { used[type] = true; });
      picked.push(cards[k]);
    }

    picked = picked.concat(skipped.slice(0, limit - picked.length));

    grid.replaceChildren.apply(grid, picked);
    pool.remove();
  }

  function initAll(root) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-ttp-shuffle]'), shuffle);
  }

  initAll(document);

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
